var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "modal" } }, [
    _c(
      "div",
      {
        staticClass: "vue-modal-mask",
        class: _vm.verticalPositionClass,
        on: {
          click: function ($event) {
            return _vm.close("background")
          },
        },
      },
      [
        _c(
          "div",
          {
            staticClass: "vue-modal-container",
            class: _vm.sizeClass,
            attrs: { role: "dialog" },
            on: {
              click: function ($event) {
                $event.stopPropagation()
              },
            },
          },
          [
            _c(
              "div",
              { staticClass: "vue-modal-wrapper", attrs: { role: "document" } },
              [
                _c(
                  "div",
                  { staticClass: "vue-modal-header" },
                  [
                    _vm._t("header"),
                    _vm._v(" "),
                    _vm._t("header-close", function () {
                      return [
                        _c(
                          "button",
                          {
                            staticClass: "vue-modal-header-close",
                            attrs: { type: "button", "aria-label": "Close" },
                            on: {
                              click: function ($event) {
                                return _vm.close("modal")
                              },
                            },
                          },
                          [
                            _c("span", { attrs: { "aria-hidden": "true" } }, [
                              _vm._v("×"),
                            ]),
                          ]
                        ),
                      ]
                    }),
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "vue-modal-body" },
                  [_vm._t("body")],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "vue-modal-footer" },
                  [_vm._t("footer")],
                  2
                ),
              ]
            ),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }